import React from 'react'
import { Rate } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type StarRateProps = {
  value?: number
  onChange?: (val?: number) => void
  className?: string
  disabled?: boolean
  allowClear?: boolean
  count?: number
}

export const StarRate: React.FC<StarRateProps> = ({
  value,
  onChange,
  className,
  disabled,
  allowClear = false,
}) => {
  return (
    <Rate
      className={className}
      value={value}
      onChange={onChange}
      disabled={disabled}
      allowClear={allowClear}
    />
  )
}

type AntdFormStarRateProps = {
  className?: string
  disabled?: boolean
  allowClear?: boolean
  count?: number
} & AntdFormItemProps

export const AntdFormStarRate: React.FC<AntdFormStarRateProps> = ({
  fieldProps,
  className,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <StarRate {...props} className={cn(className)} />
    </AntdFormItem>
  )
}
